var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 17,
    viewBox: "0 0 35 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.000465393,
    y: 0.848633,
    width: 35,
    height: 16,
    rx: 8,
    fill: "#03C75A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4328 6.03045V11.8486H12.4953L9.7538 7.88556H9.7055V11.8486H8.65152V6.03045H9.59471L12.3333 9.99636H12.3845V6.03045H13.4328ZM14.5812 11.8486V6.03045H18.3653V6.91397H15.6352V8.49352H18.1693V9.37704H15.6352V10.9651H18.388V11.8486H14.5812ZM20.665 11.8486L19.023 6.03045H20.1565L21.2048 10.306H21.2588L22.3781 6.03045H23.4093L24.5315 10.3089H24.5826L25.6309 6.03045H26.7644L25.1224 11.8486H24.0826L22.9179 7.76625H22.8724L21.7048 11.8486H20.665Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew);
export default __webpack_public_path__ + "static/media/New.95176c33b0b7e2d0a88c0b0a72801c2f.svg";
export { ForwardRef as ReactComponent };